import { render, staticRenderFns } from "./TabelaAreaAcaoPilar.vue?vue&type=template&id=632871ba&scoped=true"
import script from "./TabelaAreaAcaoPilar.vue?vue&type=script&lang=js"
export * from "./TabelaAreaAcaoPilar.vue?vue&type=script&lang=js"
import style0 from "./TabelaAreaAcaoPilar.vue?vue&type=style&index=0&id=632871ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632871ba",
  null
  
)

export default component.exports